import * as React from "react";
const SvgChair = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.857 1.25h.286c1.196 0 2.75-.002 4.017.393.675.21 1.332.55 1.82 1.114.502.578.77 1.328.77 2.243 0 2.093-.229 3.519-.403 4.508a2.627 2.627 0 0 1-.223 5.242h-.274l.894 7.157a.75.75 0 0 1-1.488.186l-.918-7.343H7.662l-.918 7.343a.75.75 0 0 1-1.488-.186l.894-7.157h-.275a2.626 2.626 0 0 1-.222-5.242A24.41 24.41 0 0 1 5.25 5c0-.915.268-1.665.77-2.243.488-.564 1.145-.904 1.82-1.114 1.268-.395 2.821-.394 4.017-.393Zm5.155 12H7.01a.79.79 0 0 0-.022 0H5.875a1.125 1.125 0 1 1 .14-2.242l1.892.236.046.006H16.047l.046-.006 1.892-.236a1.125 1.125 0 1 1 .14 2.242h-1.113ZM7.2 9.644l.847.106h7.906l.847-.106.036-.201c.174-.986.414-2.343.414-4.443 0-.605-.17-.991-.403-1.26-.245-.284-.62-.505-1.133-.664-1.045-.326-2.401-.326-3.678-.326h-.072c-1.277 0-2.633 0-3.678.326-.514.16-.888.38-1.133.663-.234.27-.403.656-.403 1.261 0 2.1.24 3.457.414 4.443l.036.201Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgChair;
